@if (showError) {
  <div>
    <h5 class="text-success font-weight-bold">Don't refresh this page..</h5>
    <h5 class="text-success text-capitalize font-weight-bold font-italic">Redirecting.. </h5>
  </div>
}
@for (d of gatewaydetails; track d) {
  <div class="border border-secondary rounded py-2 px-1 my-2">
    @if (!this.getConfig$()) {
      <div class="custom-control custom-radio">
        <input type="radio" class="custom-control-input" id="dis{{d.id}}" name="defaultExampleRadios"
          (click)="proceedPayment(d)">
        <label class="custom-control-label" for="dis{{d.id}}">{{d.displayName}}</label>
      </div>
    }
    @if (this.getConfig$()) {
      <div class="custom-control custom-radio">
        <input type="radio" class="custom-control-input" id="dis{{d.systemId}}" name="defaultExampleRadios"
          (click)="proceedResponse$(d)">
        <label class="custom-control-label" for="dis{{d.systemId}}">{{d.systemName}}</label>
      </div>
    }
  </div>
}